module.exports = __webpack_public_path__ + "static/img/img2.bee497c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feature/img2.png
// module id = 6fB0
// module chunks = 1